import React, { FunctionComponent } from 'react'

import { KINDS, SIZES } from './constants'
import { Circle } from './Circle'
import { Bar } from './Bar'

type KindsType = typeof KINDS
type KindsKeys = keyof KindsType
export type PaymentProgressKinds = KindsType[KindsKeys]

type SizesType = typeof SIZES
type SizesKeys = keyof SizesType
export type PaymentProgressSizes = SizesType[SizesKeys]

export type StepType = number | string

export interface PaymentProgressProps {
  kind?: PaymentProgressKinds
  size?: PaymentProgressSizes
  step?: StepType
  maxStep?: StepType
  paymentLabel?: string
  paymentDescription?: string
  title?: string
  description?: string
  testNameSpace?: string
  isSubsidiary?: boolean
}

export type PaymentProgressVariantComponent = FunctionComponent<PaymentProgressProps>

export type PaymentProgressComponent = PaymentProgressVariantComponent & {
  Circle: PaymentProgressVariantComponent
  Bar: PaymentProgressVariantComponent
}

const BasePaymentProgress: PaymentProgressVariantComponent = ({
  kind,
  paymentLabel,
  paymentDescription,
  title,
  description,
  isSubsidiary = false,
  ...others
}) => {
  return kind === KINDS.BAR ? (
    <Bar {...others} />
  ) : (
    <Circle
      {...others}
      paymentLabel={paymentLabel}
      paymentDescription={paymentDescription}
      title={title}
      description={description}
      isSubsidiary={isSubsidiary}
    />
  )
}

export const PaymentProgress = BasePaymentProgress as PaymentProgressComponent

const PaymentProgressCircle: PaymentProgressVariantComponent = ({ kind, ...others }) => <Circle {...others} />
const PaymentProgressBar: PaymentProgressVariantComponent = ({ kind, ...others }) => <Bar {...others} />

PaymentProgress.Circle = PaymentProgressCircle
PaymentProgress.Bar = PaymentProgressBar
